import { render, staticRenderFns } from "./MyComponent-Header.vue?vue&type=template&id=17a1c41c&scoped=true"
import script from "./MyComponent-Header.vue?vue&type=script&lang=js"
export * from "./MyComponent-Header.vue?vue&type=script&lang=js"
import style0 from "./MyComponent-Header.vue?vue&type=style&index=0&id=17a1c41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1c41c",
  null
  
)

export default component.exports